/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The source the meeting was created from
 * @export
 * @enum {string}
 */
export enum SourceType {
    Careplatform = 'CAREPLATFORM',
    Takecare = 'TAKECARE',
    Webdoc = 'WEBDOC',
    Cgmj4 = 'CGMJ4'
}

export function SourceTypeFromJSON(json: any): SourceType {
    return SourceTypeFromJSONTyped(json, false);
}

export function SourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceType {
    return json as SourceType;
}

export function SourceTypeToJSON(value?: SourceType | null): any {
    return value as any;
}

